<template>
  <UContainer as="main" class="w-full max-w-none sm:px-0 lg:px-0 px-0">
    <HomeJumbotron />
    <LazyHomeGridCategorias />
    <ClientOnly>
      <LazyHomeEstatisticas />
    </ClientOnly>
    <HomeParallax />
    <ClientOnly>
      <HomeCursosDestaque />
      <HomeDepoimentos />
    </ClientOnly>
    <LazyHomeGoToTop />

    <DevBreakpointIndicator />
  </UContainer>
</template>

<script setup lang="ts">
</script>
